import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth, thirdWidth } from "../../blocks/layout/columnSpans";

/**
 * Season as page config. EntityPage summarises created and modified in the footer.
 */
export const seasonPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "dwseason",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 9, mobile: 12 },
          blocks: [
            {
              kind: "section",
              id: "section-season",
              // The page bar already names the record.
              title: "",
              fields: [
                {
                  id: "field-name",
                  type: "text",
                  name: "name",
                  label: "Name",
                  required: true,
                  isNameField: true,
                  span: thirdWidth,
                },
                {
                  id: "field-seasonstart",
                  type: "date",
                  name: "seasonstart",
                  label: "Start",
                  span: thirdWidth,
                },
                {
                  id: "field-seasonend",
                  type: "date",
                  name: "seasonend",
                  label: "End",
                  span: thirdWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 3, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-season-flags",
              title: "Season Flags",
              fields: [
                {
                  id: "field-islastseason",
                  type: "boolean",
                  name: "islastseason",
                  label: "Is Last Season",
                  span: fullWidth,
                },
                {
                  id: "field-isthisseason",
                  type: "boolean",
                  name: "isthisseason",
                  label: "Is This Season",
                  span: fullWidth,
                },
                {
                  id: "field-isnextseason",
                  type: "boolean",
                  name: "isnextseason",
                  label: "Is Next Season",
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
